import { ServerIcon } from "@heroicons/react/24/outline";
import { ActionButton } from "@via/components/action-button/action-button";

export function SuggestedApp({
  app,
  isLaunchAppLoading,
  handleLaunchApp,
}: {
  app: {
    id: number;
    name: string;
    image: string;
    description?: string;
  };
  isLaunchAppLoading: boolean;
  handleLaunchApp: (appId: number) => void;
}): JSX.Element {
  return (
    <div
      key={app.id}
      className="flex flex-col justify-between min-w-sm overflow-hidden rounded-lg bg-white shadow-lg p-4">
      <div className="flex items-start space-x-4">
        <div className="rounded-full bg-blue-100 p-2">
          <ServerIcon className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-gray-800 line-clamp-3 break-all">
            {app.name}
          </h3>
          <p className="text-sm text-black line-clamp-3 break-all pt-2">
            {app.image}
          </p>
          <p className="mt-1 text-sm text-gray-500 line-clamp-3">
            {app.description}
          </p>
        </div>
      </div>
      <div className="flex justify-end py-3">
        <ActionButton
          disabled={isLaunchAppLoading}
          showIcon={false}
          button="Launch App"
          primary={true}
          onClick={() => handleLaunchApp(app.id)}
        />
      </div>
    </div>
  );
}
